import { ref } from "vue";

// Estado a nivel de módulo: singleton compartido entre todos los componentes
const panelAbierto = ref(false);

export function usePerfilPanel() {
  function abrir() {
    panelAbierto.value = true;
  }

  function cerrar() {
    panelAbierto.value = false;
  }

  return { panelAbierto, abrir, cerrar };
}
